import makeStyles from '@mui/styles/makeStyles';

import SearchBox from './SearchBox';

const useStyles = makeStyles((theme) => ({
    searchBoxRoot: {
        alignSelf: "flex-end",
        "& .MuiTextField-root": {
            width: "100%",
        },
        "& .MuiInputBase-input": {
            padding: 0,
        },
        "& .MuiInputBase-root": {
            padding: theme.spacing(2),
            paddingRight: 0,
            borderWidth: "0 0 2px",
            borderColor: "transparent",
            "&.Mui-focused": {
                borderBottomColor: "#fff",
                "& .MuiInput-input::placeholder": {
                    color: "hsla(0, 0%, 100%, .3)",
                }
            },
            "&:hover": {
                "& .MuiInput-input::placeholder": {
                    color: theme.palette.primary.main,
                },
            },
        },
        "& .MuiInput-input::placeholder": {
            ...theme.typography.button,
            color: "hsla(0, 0%, 100%, .7)",
            transition: theme.transitions.create(['all']),
        },
    },
}));

export default function CategoryListSearchBox({ searchQuery = "", onInput = ()=>{}, onSubmit = ()=>{}, placeholderText="Search categories..." }) {
    const classes = useStyles();
    
    return (
        <>
            <SearchBox 
                value={searchQuery}
                rootClassName={classes.searchBoxRoot}
                placeholder={placeholderText}
                onInput={onInput}
                onSubmit={onSubmit}
                onBlur={onSubmit} 
            />
        </>
    );
}
